import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import CompaniesFormContainer from '../../../../Containers/AdminContainer/Companies/CompaniesForm';
const CompaniesFormScreen = () => {
  return <CompaniesFormContainer />;
};

export default CompaniesFormScreen;
